// extracted by mini-css-extract-plugin
module.exports = {"link":"src-widgets-EventConnectedInfo-components-Link-styles__link--2v9Qu","icon":"src-widgets-EventConnectedInfo-components-Link-styles__icon--8Uwfk"};